/**
 * WordPress dependencies
 */
import { _x } from '@wordpress/i18n';

/**
 * Internal dependencies
 */
import image from './dawn.png';

export default {
	image,
	value: 'dawn' as const,
	label: _x( 'Dawn', 'text', 'nelio-maps' ),

	/* eslint-disable-next-line */
	json: [
		{
			featureType: 'administrative',
			elementType: 'all',
			stylers: [ { visibility: 'on' }, { lightness: 33 } ],
		},
		{
			featureType: 'landscape',
			elementType: 'all',
			stylers: [ { color: '#f2e5d4' } ],
		},
		{
			featureType: 'poi.park',
			elementType: 'geometry',
			stylers: [ { color: '#c5dac6' } ],
		},
		{
			featureType: 'poi.park',
			elementType: 'labels',
			stylers: [ { visibility: 'on' }, { lightness: 20 } ],
		},
		{
			featureType: 'road',
			elementType: 'all',
			stylers: [ { lightness: 20 } ],
		},
		{
			featureType: 'road.highway',
			elementType: 'geometry',
			stylers: [ { color: '#c5c6c6' } ],
		},
		{
			featureType: 'road.arterial',
			elementType: 'geometry',
			stylers: [ { color: '#e4d7c6' } ],
		},
		{
			featureType: 'road.local',
			elementType: 'geometry',
			stylers: [ { color: '#fbfaf7' } ],
		},
		{
			featureType: 'water',
			elementType: 'all',
			stylers: [ { visibility: 'on' }, { color: '#acbcc9' } ],
		},
	],
};
